import { render, staticRenderFns } from "./monthlyFundsPlan.vue?vue&type=template&id=2723b688&scoped=true&"
import script from "./monthlyFundsPlan.vue?vue&type=script&lang=js&"
export * from "./monthlyFundsPlan.vue?vue&type=script&lang=js&"
import style0 from "./monthlyFundsPlan.vue?vue&type=style&index=0&id=2723b688&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2723b688",
  null
  
)

export default component.exports